/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-12 15:40.
 */
const Server = require( 'helper/server' );

const baseinfo = Handlebars.templates[ 'purchasing-federation/member-info/templates/baseinfo' ];
const unitTypeMap = {
  '01': '供应商',
  '02': '采购人',
  '03': '集采机构',
  '04': '代理机构',
  '05': '咨询机构',
  '06': '行业协会'
};
const Membership = {
  1: '会长',
  2: '副会长单位',
  3: '常务理事',
  4: '理事',
  5: '单位会员-非事业单位',
  6: '单位会员-事业单位'
};
const BaseInfo = {
  async init() {
   const spiner = this.$el.find( '.block__content' ).spin();
   try {
      const data = await Server.getMemberDetail();
      const { memberBaseInfo, mailAddress } = data;
      const { unitType = '', memberType = '' } = memberBaseInfo || {};
      const unitTypeNames = unitType.split( ',' ).map( type => {
        return unitTypeMap[ type ];
      } );
      const memberTypeName = memberType == 1 ? '单位会员' : '个人会员';
      memberBaseInfo.memberTypeName=memberTypeName;
      memberBaseInfo.unitTypeName = unitTypeNames.join( ',' );
      const membership = memberBaseInfo.membership.split( ',' ).map( x => {
        return `${ Membership[ x ] }  `;
      } );
      memberBaseInfo.membership = membership.join( ',' );
      const html = baseinfo( { DATA: data } );
      this.$el.find( '.info-wrap' ).html( html );
    }
    catch ( e ) {
      alert( e.responseText || '未知错误' );
    }
    spiner.stop();
  }
};

module.exports = BaseInfo;
